import React from "react";
import { ArrowBackCircle, TrashOutline, AddCircle } from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import stylesASAP from "./stylesASAP"
import stylesWMS from "../WMS/stylesWMS"
import _post from "../Functions/Post"
import _postBody from "../Functions/Post";
import constantURI from "../URI"
import ASAPAuthenticate from "../Functions/ASAPAuthenticate"
import stylesMed from "../MedRep/stylesMed"
import { Modal } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import SignaturePad from 'react-signature-pad-wrapper'
import normalizeUnsyncedTransactions from "../Functions/normalizeUnsyncedTransactions";

export default class PaymentCashSale extends React.Component {

    constructor() {
        super();
        this.state = {
            amounts: [], authenticate: false, token: "", loading: true, alertUndefined: false, paymentTypes: [],
            clientCurrency: [], currentCurrency: "", primaryRate: "", rates: [], invoices: [], clientName: "", clientId: -1, showDeleteAlert: false,
            totalAmount: "", currentIndex: -1, totalPayment: 0, preventSymbols: ["e", "E", "+", "-"], isVendor: false, paymentId: -1,
            URLs: [{ type: "", clientType: -1 }], remainingAmount: 0, invalidAmount: false, currentType: 3, count: 0, USP: [], originalPayments: [],
            originalCount: [], selectedClient: -1, selectedClientName: "", showSignatureAlert: false, checkSignature: true, signature: "", user: [],
            dailySummaryReport: [], username: ""
        }
        this.sign = React.createRef();
    }

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        //Check internet connectivity
    
        const token = JSON.parse(localStorage.getItem('Token'));
        const client = JSON.parse(localStorage.getItem('SelectedClientDetails'));
        const pendingInvoices = JSON.parse(localStorage.getItem("PendingInvoices"));
        const dailySummaryReport = JSON.parse(localStorage.getItem('DailySummaryReport'));
        const user = JSON.parse(localStorage.getItem("User"));
        const isVendor = JSON.parse(localStorage.getItem("isVendor"));
        const username = JSON.parse(localStorage.getItem("Username"));
        const clientName = JSON.parse(localStorage.getItem("SelectedClientName"));
        const total = JSON.parse(localStorage.getItem('Total'));
        await this.setState({
            token: token, username: username, clientCurrency: client.currency_id, selectedClient: client.id, user: user, selectedClientName: client.name, clientName : clientName , totalAmount : total ,
            invoices: pendingInvoices, isVendor: isVendor, dailySummaryReport: (dailySummaryReport.length === 0) ? [{ "ordered": 0, "visited": 0, "collection": 0, "OOR": 0 }] : dailySummaryReport
        });

        //Setting Data from local storage
        const { counts: count, transactions: payments } = normalizeUnsyncedTransactions();

        await this.setState({
            count: (count.length !== 0 && count[this.state.currentType] !== undefined) ? count[this.state.currentType] : 0,
            USP: (payments.length !== 0 && payments[this.state.currentType] !== undefined) ? payments[this.state.currentType] : [],
            originalPayments: payments, originalCount: count
        });

        //Get Client's name and how much did he pay
        // this.getClientNameAndAmount();

        //Check if selected client is customer or vendor (Receipt or Payment)
        if (isVendor) {
            await this.setState({ ...this.state.URLs[0].clientType = 3 });
        }
        else {
            await this.setState({ ...this.state.URLs[0].clientType = 1 });
        }

        const getPaymentType = constantURI() + "GetPaymentType?token=" + this.state.token + "&user=" + this.state.username;
        const getRate = constantURI() + "GetRate?token=" + this.state.token + "&user=" + this.state.username;

        //If online
        // if (this.state.authenticate) {
        //     //Get PaymentTypes based on client
        //     await _post(getPaymentType).then((response) => {
        //         return response.json().then((data) => {
        //             if (data.result !== undefined) {
        //                 this.setState({ paymentTypes: data.result })
        //                 localStorage.setItem('PaymentTypes', JSON.stringify(this.state.paymentTypes));
        //             } else {
        //                 this.setState({ alertUndefined: true });
        //             }
        //         })
        //     });
        //     //Get rates
        //     await _post(getRate).then((response) => {
        //         return response.json().then((data) => {
        //             if (data.result !== undefined) {
        //                 this.setState({ rates: data.result, loading: false })
        //                 localStorage.setItem('Rates', JSON.stringify(this.state.rates));
        //             } else {
        //                 this.setState({ alertUndefined: true });
        //             }
        //         })
        //     })
        // }
        //If offline
        
            const journals = localStorage.getItem('Journals');
            const PaymentTypes = localStorage.getItem('PaymentTypes');
            const rates = localStorage.getItem('Rates');
            this.setState({ journals: JSON.parse(journals), rates: JSON.parse(rates), paymentTypes: JSON.parse(PaymentTypes), loading: false });
        
        this.setRates();
        this.setPaymentTypeBeginning();
    }

    //Get the client's name and the amount paid based on the selected invoices in the previous page
    // getClientNameAndAmount = async () => {
    //     var total = 0;
    //     var name = "";
    //     var id = -1;
    //     await this.state.invoices.map((item) => {
    //         if (item.amountToPay !== undefined)
    //             total += item.amountToPay
    //         name = item.partner_id[1]
    //         id = item.partner_id[0];
    //     });
    //     this.setState({  clientId: id });
    // }

    //Set the primary rate based on the client's currency
    setRates = () => {
        var isFound = false;
        this.state.rates.some((rate) => {
            if (rate.currency_id[0] === this.state.clientCurrency[0] && !isFound) {
                this.setState({ primaryRate: rate.rate });
                isFound = true;
            }
        })
    }

    onSelectType = (index) => async (e) => {
        //Set selected payment method
        await this.setState({ ...this.state.amounts[index].payType = Number(e.target.value), ...this.state.amounts[index].amount = 0, ...this.state.amounts[index].convertedAmount = 0 });
        //Set the currency of the selected method
        await this.state.paymentTypes.map((item) => {
            if (item.id === Number(e.target.value)) {
                this.setState({
                    ...this.state.amounts[index].currenyId = item.currency_id,
                    ...this.state.amounts[index].paymentType = item.paymentType
                });
            }
        })
        //Set the rate of the selected method
        var isFound = false;
        await this.state.rates.map((item) => {
            if (item.currency_id[0] === this.state.amounts[index].currenyId[0] && !isFound) {
                this.setState({ ...this.state.amounts[index].rate = item.rate });
                isFound = true;
            }
        });
        await this.calculateRemainingAmountPrimaryCurrency();
        await this.calculateRemainingAmountSelectedCurrency(index);
    }

    onChangeAmount = (index) => async (e) => {
        //Set the entered amount and convert it to the client's currency
        await this.setState({ ...this.state.amounts[index].amount = Number(e.target.value), ...this.state.amounts[index].convertedAmount = Number(((((e.target.value > this.state.totalAmount) ? this.state.totalAmount : e.target.value)/ this.state.amounts[index].rate) * this.state.primaryRate).toFixed(2)) });
        await this.setTotalPaymentAmount();
        await this.calculateRemainingAmountPrimaryCurrency();
        if (this.state.invalidAmount) {
            await this.setState({ ...this.state.amounts[index].amount = this.state.amounts[index].amount - Number(e.target.value), ...this.state.amounts[index].convertedAmount = this.state.amounts[index].convertedAmount - Number(((((e.target.value > this.state.totalAmount) ? this.state.totalAmount : e.target.value)/ this.state.amounts[index].rate) * this.state.primaryRate).toFixed(2)) });
        }
    }

    setTotalPaymentAmount = async () => {
        var total = 0;
        await this.state.amounts.map((item) => {
            total += Number(item.convertedAmount);
        });
        await this.setState({ totalPayment: total });
    }

    //Set the first payment method to the client's currency and put the default amount to the total paid amount
    setPaymentTypeBeginning = async () => {
        await this.state.paymentTypes.map((item) => {
            if (item.currency_id[0] === this.state.clientCurrency[0]) {
                this.setState({
                    ...this.state.amounts[0] = {}, ...this.state.amounts[0].payType = item.id,
                    ...this.state.amounts[0].currenyId = item.currency_id,
                    ...this.state.amounts[0].amount = this.state.totalAmount,
                    ...this.state.amounts[0].rate = this.state.primaryRate,
                    ...this.state.amounts[0].paymentType = item.paymentType,
                    ...this.state.amounts[0].payType = item.id,
                    ...this.state.amounts[0].convertedAmount = Number((this.state.totalAmount).toFixed(2)),
                    totalPayment: this.state.totalAmount
                });
            }
        });
    }

    incrementLastReceiptNumber = async () => {
        var tempUser = this.state.user;
        tempUser[0].last_receipt_number++;
        await this.setState({ user: tempUser });
        localStorage.setItem("User", JSON.stringify(this.state.user));
    }

    saveOnline = async (createReceipt, receiptUUID) => {
        this.setState({ loading: true });
        var body = {};
        var temp = [];
        await this.state.amounts.map((item, index) => {
            temp[index] = {};
            temp[index].amount = item.amount;
            temp[index].receipt_amount = item.convertedAmount;
            temp[index].currency_id = item.currenyId[0];
            temp[index].payment_type_id = item.payType;
            temp[index].receiptNum = "RCT-" + receiptUUID;
        });
        body.lines = temp;

        await _postBody(createReceipt, body).then((response) => {
            return response.json().then(async (data) => {
                if (data.result === undefined)
                    alert("Please try again");
                else {
                    await this.setState({ paymentId: data.result });
                    const updateSignature = constantURI() + "UpdateReceipt?token=" + this.state.token + "&user=" + this.state.username + "&id=" + this.state.paymentId;
                    var body = {};
                    body.signature = this.state.signature.substring(22);
                    await _postBody(updateSignature, body);
                    const updateUser = constantURI() + "UpdateUser?token=" + this.state.token + "&user=" + this.state.username + "&userId=" + this.state.user[0].id + "&LastReceiptNum=" + (Number(this.state.user[0].last_receipt_number) + 1);
                    await _post(updateUser);
                    console.log(updateUser);
                    this.incrementLastReceiptNumber();
                }
            })
        });
        await this.state.invoices.map(async (invoice, index, array) => {
            const createReceiptInvoices = constantURI() + "CreateTransReceipt?token=" + this.state.token + "&user=" + this.state.username + "&moveId=" + invoice.id
                + "&paymentId=" + this.state.paymentId + "&amount=" + invoice.amountToPay;
            const updateInvoice = constantURI() + "UpdateInvoice?token=" + this.state.token + "&user=" + this.state.username + "&id=" + invoice.id
                + "&amount=" + ((invoice.amount_total - invoice.amount_residual) + invoice.amountToPay);
            await _post(createReceiptInvoices).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result === undefined)
                        alert("Please try again");
                    else {
                        console.log(data.result);
                    }
                })
            })
            await _post(updateInvoice).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result === undefined)
                        alert("Please try again");
                    else {
                        console.log(data.result);
                    }
                })
            })
            if (index === array.length - 1) {
                localStorage.setItem("PendingInvoices", JSON.stringify([]));
                this.props.history.push("./Receipt");
            }
        });
        //Not needed FOR NOW
        //await this.state.amounts.map(async (amount) => {
        //    const createReceiptLines = constantURI() + "CreateReceiptLines?token=" + this.state.token+ "&user=" + this.state.username + "&amount=" + amount.amount + "&paymentId=" + this.state.paymentId +
        //        "&account=" + amount.accountId + "&method=" + Number(amount.payType) + "&type=" + amount.paymentType + "&currency=" + amount.currenyId[0];
        //    console.log(createReceiptLines)
        //    await _post(createReceiptLines);
        //});
    }

    saveOffline = async (createReceipt, receiptUUID) => {
        var payments = (this.state.USP === null ) ? [] : this.state.USP;
        var uuid = uuidv4();

        //Define the header of the Payment
        var temp = {};
        temp.createURL = createReceipt;
        temp.usId = this.state.count;
        temp.name = "CSH" + (this.state.count + 1);
        temp.amount_total = this.state.totalAmount.toFixed(2);
        temp.amount_residual = this.state.remainingAmount.toFixed(2);
        temp.invoice_date = new Date().toISOString().substring(0, 10);
        temp.partner_id = [];
        temp.partner_id[0] = this.state.selectedClient;
        temp.partner_id[1] = this.state.selectedClientName;
        temp.state = "Unsynced";
        temp.signatureUrl = constantURI() + "UpdateReceipt?token=" + this.state.token + "&user=" + this.state.username + "&id=" + uuid;
        temp.userUrl = constantURI() + "UpdateUser?token=" + this.state.token + "&user=" + this.state.username + "&userId=" + this.state.user[0].id + "&LastReceiptNum=" + (Number(this.state.user[0].last_receipt_number) + 1);
        temp.signature = this.state.signature.substring(22);
        this.incrementLastReceiptNumber();
        //Define the lines of the transaction
        temp.Lines = [];
        var tempBody = {
            lines: []
        };
        if (this.state.amounts.length !== 0) {
            await this.state.amounts.map((amount) => {
                if (amount.amount !== 0 && amount.amount !== undefined) {
                    var tempLine = {}; //The details to use in details page 
                    var tempItem = {}; //The body to send to the api
                    const createReceiptLines = constantURI() + "CreateReceiptLines?token=" + this.state.token + "&user=" + this.state.username + "&amount=" + amount.amount +
                        "&paymentId=" + uuid + "&account=" + amount.accountId + "&method=" + Number(amount.payType) + "&type=" +
                        amount.paymentType + "&currency=" + amount.currenyId[0];

                    tempItem.amount = amount.amount;
                    tempItem.receiptNum = "RCT-" + receiptUUID;
                    tempItem.receipt_amount = amount.convertedAmount;
                    tempItem.currency_id = amount.currenyId[0];
                    tempItem.payment_type_id = amount.payType;

                    tempLine = amount;
                    tempLine.id = uuid;
                    tempLine.URL = createReceiptLines;

                    temp.Lines.push(tempLine);
                    tempBody.lines.push(tempItem);
                }
            });
        }
        temp.Body = tempBody;

        //Define the invoices of the transaction
        temp.Invoices = [];
        if (this.state.invoices.length !== 0) {
            await this.state.invoices.map((invoice) => {
                var tempLine = {};
                const createReceiptInvoices = constantURI() + "CreateTransReceipt?token=" + this.state.token + "&user=" + this.state.username + "&moveId=" + invoice.id
                    + "&amount=" + invoice.amountToPay + "&paymentId=" + uuid;
                const updateInvoice = constantURI() + "UpdateInvoice?token=" + this.state.token + "&user=" + this.state.username + "&id=" + invoice.id
                    + "&amount=" + ((invoice.amount_total - invoice.amount_residual) + invoice.amountToPay);
                tempLine = invoice;
                tempLine.id = uuid;
                tempLine.URL = createReceiptInvoices;
                tempLine.UpdateURL = updateInvoice;

                temp.Invoices.push(tempLine);
            });
        }
        //Set this transaction and the count in the local storage
        await payments.push(temp);
        const nextCount = this.state.count + 1;
        const localCount = [...(this.state.originalCount || [])];
        localCount[this.state.currentType] = nextCount;
        this.setState({ count: nextCount, originalCount: localCount });
        const localSOs = this.state.originalPayments;
        localSOs[this.state.currentType] = payments;
        await localStorage.setItem('UnsyncedTransactionsCount', JSON.stringify(localCount));
        await localStorage.setItem('UnsyncedTransactions', JSON.stringify(localSOs));
        await this.DailySummaryReport();
        await this.props.history.push("/Receipt");
    }

    onSave = async () => {
        if (this.sign.current.isEmpty()) {
            alert("Please sign this payment");
        }
        else {
            //Check internet connectivity
          
            var uuid = uuidv4();
            this.setState({ signature: this.sign.current.toDataURL() });
            const createReceipt = constantURI() + "CreateReceipt?token=" + this.state.token + "&user=" + this.state.username + "&partnerId=" + this.state.clientId + "&name=" + "RCT-" +
                this.state.user[0].user_code + "-" + this.pad(Number(this.state.user[0].last_receipt_number), 4) + "&user=" + this.state.user[0].id + "&currencyId=" + this.state.clientCurrency[0] + "&date=" + new Date().toISOString().substring(0, 10);
            await this.saveOffline(createReceipt, uuid);
            ////If online
            //if (this.state.authenticate) {
            //    await this.saveOnline(createReceipt, uuid);
            //}
            //else {
            //}
        }
    }

    DailySummaryReport = async () => {
        await this.state.dailySummaryReport[0].collection++;
        await localStorage.setItem('DailySummaryReport', JSON.stringify(this.state.dailySummaryReport));
    }

    pad(n, length) {
        //Formating digits
        var len = length - ('' + n).length;
        return (len > 0 ? new Array(++len).join('0') : '') + n
    }

    //Add another object in the amounts array
    onClickAdd = () => {
        var temp = this.state.amounts;
        if (this.state.amounts.length === 0) {
            this.setPaymentTypeBeginning();
        }
        else {
            temp.push({});
            this.setState({ amounts: temp });
        }
    }

    //Delete the selected item and set total amount
    onDeleteItem = async () => {
        var newAmounts = this.state.amounts;
        newAmounts.splice(this.state.currentIndex, 1);
        await this.setState({ ...this.state.amounts = newAmounts });
        await this.setTotalPaymentAmount();
        await this.calculateRemainingAmountPrimaryCurrency();
        this.closeDeleteAlert();
    }

    closeDeleteAlert = () => {
        this.setState({ showDeleteAlert: false })
    }

    showDeleteAlert = (index) => {
        this.setState({ showDeleteAlert: true, currentIndex: index });
    }

    //calculating the remaining amount the client's currency
    calculateRemainingAmountPrimaryCurrency = async () => {
        var paidAmount = 0;
        await this.state.amounts.map((amount) => {
            if (amount.amount !== undefined) {
                paidAmount += amount.amount;
            }
        });
        if (Number(this.state.totalAmount.toFixed(2)) - Number(paidAmount.toFixed(2)) >= 0)
            await this.setState({ remainingAmount: Math.abs(Number(this.state.totalAmount - paidAmount).toFixed(2)), invalidAmount: false });
        else {
            await this.setState({ invalidAmount: true });
            alert("Amounts entered are greater than the total amount");
        }
    }

    //calculating the remaining amount based on the selected payment type
    calculateRemainingAmountSelectedCurrency = async (index) => {
        const convertedAmount = (this.state.amounts[index].rate * this.state.remainingAmount) / this.state.primaryRate;
        await this.setState({ ...this.state.amounts[index].amount = Number(convertedAmount), ...this.state.amounts[index].convertedAmount = Number(((convertedAmount / this.state.amounts[index].rate) * this.state.primaryRate).toFixed(2)) });
        await this.setTotalPaymentAmount();
        await this.calculateRemainingAmountPrimaryCurrency();
    }

    showSignatureAlert = async () => {
        const totalAmount = Number(this.state.totalAmount.toFixed(2));
        const totalPayment = Number(this.state.totalPayment.toFixed(2));
        //Alert the user if the entered amount is different than the total paid amount
        if (totalAmount > totalPayment || totalAmount < totalPayment) {
            this.setState({ showSignatureAlert: false });
            alert("The amount paid by the client is different than the amount entered.");
        }
        else {
            this.setState({ showSignatureAlert: true });
        }
    }

    closeSignatureAlert = () => {
        this.setState({ showSignatureAlert: false })
    }

    clearSignature = () => {
        this.sign.current.clear();
    }

    render() {
        console.log(this.state.amounts)
        if (!this.state.loading) {
            return (
                <div className="container-fluid vh-100" style={stylesASAP.mainBackgroundColor}>
                    {(!this.state.alertUndefined) ?
                        null :
                        <div className="col alert alert-danger">
                            <div className="row">
                                <h6 className="col-sm-8">There seems to be a problem.</h6>
                                <div className="col d-flex flex-row-reverse">
                                    <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                        Reload</div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="row pt-3">
                        <div className="col">
                            <ArrowBackCircle className="btn" onClick={() => { localStorage.setItem("PendingInvoices", JSON.stringify([])); this.props.history.push("./Receipt") }}
                                color={'#00bfff'}
                                height="50px"
                                width="50px"
                            />
                        </div>
                        <div className="col mt-2">
                            <h1>Payment</h1>
                        </div>
                        <div className="col d-flex flex-row-reverse">
                            <div className="btn" style={stylesASAP.saveButton} onClick={this.showSignatureAlert}>Save Payment</div>
                        </div>
                    </div>
                    <div className="m-4 p-3" style={stylesMed.cardBackgroundColor}>
                        <div className="row">
                            <p className="col">Client Name: <b>{this.state.clientName}</b></p>
                        </div>
                        <div className="row">
                            {/*<div className="col">*/}
                            {/*    <div className="row">*/}
                            {/*        <p className="col-sm-2 mt-2">Journal:</p>*/}
                            {/*        <select className="col-sm-10 form-control" style={stylesASAP.selectWidth} value={this.state.journal}*/}
                            {/*            onChange={this.onChangeJournal}>*/}
                            {/*            <option value=""></option>*/}
                            {/*            {this.state.journals.map((item) => {*/}
                            {/*                return (*/}
                            {/*                    <option value={item.id}>{item.name}</option>*/}
                            {/*                )*/}
                            {/*            })*/}
                            {/*            }*/}
                            {/*        </select>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <p className="col">Amount Paid: <b>{(this.state.totalAmount).toFixed(2) + " " + this.state.clientCurrency[1]}</b></p>
                            <p className="col">Remaining Amount: <b>{this.state.remainingAmount + " " + this.state.clientCurrency[1]}</b></p>
                        </div>
                    </div>
                    <div style={stylesASAP.mainBackgroundColor}>
                        {this.state.amounts.map((item, index) => {
                            return (
                                <div className="m-4 p-3">
                                    <hr style={stylesASAP.hr} />
                                    <div className="row">
                                        <div className="col form-group mt-1">
                                            <label>Payment Type:</label>
                                            <select className="form-control" style={stylesASAP.selectWidth} value={this.state.amounts[index].payType}
                                                disabled={(this.state.journal !== "") ? false : true} onChange={this.onSelectType(index)}>
                                                <option value=""></option>
                                                {this.state.paymentTypes.map((item) => {
                                                    return (
                                                        <option value={item.id}>{item.name}</option>
                                                    )
                                                })
                                                }
                                            </select>
                                        </div>
                                        <div className="col form-group mt-1">
                                            <label>Amount in {(this.state.amounts[index].currenyId === undefined) ? "" : this.state.amounts[index].currenyId[1]}:</label>
                                            <input className="form-control" type="number" value={this.state.amounts[index].amount} disabled={(this.state.amounts[index].payType !== "" && this.state.amounts[index].payType !== undefined) ? false : true}
                                                onChange={this.onChangeAmount(index)} style={stylesASAP.inputWidth}
                                                onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                            />
                                        </div>
                                        <div className="col form-group mt-1">
                                            <label>Amount in {this.state.clientCurrency[1]}:</label>
                                            <p style={stylesASAP.marginTitle}>{this.state.amounts[index].convertedAmount}</p>
                                        </div>
                                        <div className="col form-group mt-4">
                                            <TrashOutline className="col btn" color={'#00bfff'} height="30px" width="30px" onClick={() => this.showDeleteAlert(index)} />
                                        </div>
                                        <Modal show={this.state.showDeleteAlert} onHide={this.closeDeleteAlert} animation={false}>
                                            <Modal.Header>
                                                <Modal.Title>Are you sure you want to delete this method?</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className="btn btn-primary" style={stylesWMS.deleteButtonAlertTransfer} onClick={() => this.onDeleteItem(index)}>Delete</div>
                                                <div className="btn btn-danger" style={stylesWMS.cancelButtonAlertTransfer} onClick={() => this.closeDeleteAlert()}>Cancel</div>
                                            </Modal.Body>
                                        </Modal>
                                    </div>
                                </div>
                            )
                        })
                        }
                    </div>
                    <div style={stylesASAP.addButton}>
                        <AddCircle color={'#00bfff'} height="60px" width="60px" onClick={() => this.onClickAdd()} />
                        <p>Add Another Payment Method</p>
                    </div>
                    <div className="m-4 p-3">
                        <h2>Total: {Number(this.state.totalPayment).toFixed(2) + " " + this.state.clientCurrency[1]}</h2>
                    </div>
                    <Modal show={this.state.showSignatureAlert} onHide={this.closeSignatureAlert} animation={false}>
                        <div className="col">
                            <ArrowBackCircle className=" btn" onClick={() => this.closeSignatureAlert()} color={'#00bfff'} height="50px" width="50px" />
                        </div>
                        <Modal.Body className="text-center"><h1>Signature</h1></Modal.Body>
                        <Modal.Body><div>
                            <div>
                                <div className="pt-3 row">
                                    <div className="col d-flex flex-row-reverse">
                                        <div className="btn" style={stylesASAP.wideButton} onClick={this.onSave}>Save</div>
                                        <div className="btn " style={stylesASAP.clearButton} onClick={this.clearSignature}>Clear</div>
                                    </div>
                                    <hr />
                                </div>
                                <div className="text-center mt-1 " >
                                    <SignaturePad className="text-center border" style={stylesASAP.signature} ref={this.sign} options={{ minWidth: 3, maxWidth: 3, penColor: '#00bfff' }} />
                                </div>

                            </div>
                        </div></Modal.Body>
                    </Modal>
                </div >
            );
        }
        else {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    {(!this.state.alertUndefined) ?
                        null :
                        <div className="col alert alert-danger">
                            <div className="row">
                                <h6 className="col-sm-8">There seems to be a problem.</h6>
                                <div className="col d-flex flex-row-reverse">
                                    <div className="btn" style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                        Reload</div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="row pt-3">
                        <div className="col">
                            <ArrowBackCircle className="btn" onClick={() => { localStorage.setItem("PendingInvoices", JSON.stringify([])); this.props.history.push("./Receipt") }}
                                color={'#00bfff'}
                                height="50px"
                                width="50px"
                            />
                        </div>
                        <div className="col mt-2">
                            <h1>Payment</h1>
                        </div>
                        <div className="col d-flex flex-row-reverse">
                            <div className="btn" style={stylesASAP.saveButton} onClick={this.onSave}>Save Payment</div>
                        </div>
                    </div>
                    <div className="pt-3 mt-5 text-center">
                        <div className="spinner-border" style={stylesASAP.spinner}></div>
                    </div>
                </div>
            )
        }
    }
}
